import {
  IAcceptDownsellResponse,
  ISubscriptionDownsellResponse,
} from '@dtos/Downsell'
import { client } from '@services/api/client'

export async function getSubscriptionDownsell(orderId: number | string) {
  return client.get<ISubscriptionDownsellResponse>(
    `/orders/${orderId}/downsell`,
  )
}

export async function acceptSubscriptionDownsell(orderId: number | string) {
  return client.put<IAcceptDownsellResponse>(
    `/orders/${orderId}/downsell/accept`,
  )
}

export async function declineSubscriptionDownsell(orderId: number | string) {
  return client.put(`/orders/${orderId}/downsell/decline`)
}
